<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row">
                    <i class="fa fa-hospital"></i>
                    <span class="card-label fs-3 ms-1">
                        Quản lý trạm y tế
                    </span>
                </h3>
            </div>

            <div class="card-body">
                <el-row :gutter="10">

                    <el-col :xs="24" :sm="24" :md="12" :lg="8">
                        <label>Tên trạm:</label>

                        <el-input clearable placeholder="Tên trạm..." v-model="search.cTenTram" />
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="8">
                        <label>Mô tả:</label>

                        <el-input clearable placeholder="Mô tả..." v-model="search.cMoTa" />
                    </el-col>

                    <el-col :xs="24" :sm="24" :md="12" :lg="8">
                        <label>Trạng thái:</label>

                        <el-row :gutter="10">

                            <el-col :span="20">

                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">

                                    <el-option label="Tất cả" value="" />

                                    <el-option label="Hoạt động" :value="1" />

                                    <el-option label="Đã xóa" :value="0" />

                                </el-select>

                            </el-col>

                            <el-col :span="4">

                                <el-button plain type="primary" @click="handleFindPage">
                                    <i class="fa fa-search"></i>
                                </el-button>

                            </el-col>

                        </el-row>

                    </el-col>

                </el-row>

            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">

            <div class="card-header py-3">

                <div class="body-function">

                    <div class="col-md-6">

                        <el-button plain type="primary" @click="handleOpenAdd" data-bs-toggle="modal"
                            data-bs-target="#modal_news">

                            <span class="btn-inner--icon">
                                <i class="fas fa-plus"></i>
                            </span>

                            <span class="btn-inner--text">
                                &nbsp;Thêm trạm y tế
                            </span>

                        </el-button>

                    </div>

                </div>

            </div>

            <div class="card-body">

                <div class="col-md-12 tbl">

                    <el-table :data="tableData.content" stripe fit height="100%">

                        <el-table-column prop="nMaTramYTe" label="Mã" width="80" align="center" />

                        <el-table-column prop="cTenTram" label="Tên trạm" />

                        <el-table-column prop="cMoTa" label="Mô tả" />

                        <el-table-column prop="cSdt" label="SĐT" width="140" />

                        <el-table-column prop="cDiaChi" label="Địa chỉ" />

                        <el-table-column label="Google Map" width="120">

                            <template #default="scope">

                                <a v-if="scope.row.cGoogleMapUrl" :href="scope.row.cGoogleMapUrl" target="_blank">
                                    Xem
                                </a>

                            </template>

                        </el-table-column>

                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120" align="center">

                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayTao) }}
                            </template>

                        </el-table-column>

                        <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">

                            <template #default="scope">

                                <el-tag type="success" v-if="scope.row.nTinhTrang == 1">
                                    Hoạt động
                                </el-tag>

                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0">
                                    Đã xóa
                                </el-tag>

                            </template>

                        </el-table-column>

                        <el-table-column label="Hành động" width="180" align="center">

                            <template #default="scope">

                                <el-button plain type="primary" data-bs-toggle="modal" data-bs-target="#modal_news"
                                    @click="handleOpenEdit(scope.row)">
                                    <i class="fas fa-edit"></i>
                                </el-button>

                                <el-button plain type="danger" @click="handleDelete(scope.row)">
                                    <i class="fas fa-trash"></i>
                                </el-button>

                            </template>

                        </el-table-column>

                    </el-table>

                </div>

            </div>

            <div class="col-12 py-2 pagination" style="justify-content:end">

                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize" />

            </div>

        </div>

        <div class="modal fade" id="modal_news" ref="newsModalRef" tabindex="-1">

            <div class="modal-dialog modal-dialog-centered mw-1000px">

                <div class="modal-content">

                    <div class="modal-header">

                        <h2 class="fw-bolder">

                            {{
                                !operation
                                    ? "Thêm trạm y tế"
                                    : "Cập nhật trạm y tế"
                            }}

                        </h2>

                        <div class="btn btn-sm btn-icon" data-bs-dismiss="modal" @click="handleClose">
                            ✕
                        </div>

                    </div>

                    <div class="modal-body mh-600px overflow-scroll">

                        <el-form :model="formData" :rules="rules" ref="formDataRef" label-width="140px"
                            class="d-flex flex-column">

                            <el-form-item label="Tên trạm" prop="cTenTram">
                                <el-input v-model="formData.cTenTram" />
                            </el-form-item>

                            <el-form-item label="Mô tả" prop="cMoTa">
                                <el-input type="textarea" :rows="4" v-model="formData.cMoTa" />
                            </el-form-item>

                            <el-form-item label="Số điện thoại" prop="cSdt">
                                <el-input v-model="formData.cSdt" />
                            </el-form-item>

                            <el-form-item label="Địa chỉ" prop="cDiaChi">
                                <el-input v-model="formData.cDiaChi" />
                            </el-form-item>

                            <el-form-item label="Google Map URL" prop="cGoogleMapUrl">
                                <el-input v-model="formData.cGoogleMapUrl" />
                            </el-form-item>

                            <el-form-item label="Hình ảnh" prop="imageFile">

                                <el-upload action="#" list-type="picture-card" :auto-upload="false"
                                    :file-list="imageFile" :on-change="handleChangeFile" :on-remove="handleRemoveFile"
                                    :on-preview="handlePictureCardPreview">

                                    <i class="el-icon-plus"></i>

                                </el-upload>

                            </el-form-item>

                        </el-form>

                    </div>

                    <div class="modal-footer">

                        <el-button plain type="primary" @click="handleSave">
                            {{ operation ? "Lưu" : "Thêm" }}
                        </el-button>

                        <el-button plain type="danger" @click="handleClose">
                            Thoát
                        </el-button>

                    </div>

                </div>

            </div>

        </div>

        <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">

            <img class="mh-500px mw-1000px" :src="dialogImageUrl" />

        </el-dialog>

    </div>
</template>
<script>
import { Medical } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";

export default {
    name: "medical",

    data() {
        return {
            perms: CookieComponent.get("permissions")
                ? JSON.parse(CookieComponent.get("permissions"))
                : [],

            search: {
                cTenTram: "",
                cMoTa: "",
                nTinhTrang: null
            },

            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },

            formData: {
                cTenTram: "",
                cMoTa: "",
                cSdt: "",
                cDiaChi: "",
                cGoogleMapUrl: "",
                imageFile: []
            },

            rules: {
                cTenTram: [
                    {
                        required: true,
                        message: "Xin vui lòng nhập tên trạm",
                        trigger: "blur"
                    }
                ],

                cMoTa: [
                    {
                        required: true,
                        message: "Xin vui lòng nhập mô tả",
                        trigger: "blur"
                    }
                ],

                cDiaChi: [
                    {
                        required: true,
                        message: "Xin vui lòng nhập địa chỉ",
                        trigger: "blur"
                    }
                ],

                /* imageFile: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.imageFile.length == 0) {
                                callback(new Error("Xin vui lòng chọn hình ảnh"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ] */
            },

            tableData: {
                content: [{}]
            },

            store: useStore(),
            isLoading: false,
            operation: false,
            imageFile: [],
            dialogImageUrl: null,
            dialogVisible: false
        };
    },

    methods: {
        handleCheckPerms(val) {
            return this.perms.includes(val);
        },

        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : "";
        },

        handleChangePageNum(val) {
            this.pageRequest.pageNum = val;
            this.handleFindPage();
        },

        handleChangePageSize(val) {
            this.pageRequest.pageSize = val;
            this.handleFindPage();
        },

        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTenTram: {
                    value: this.search.cTenTram
                },
                cMoTa: {
                    value: this.search.cMoTa
                },
                nTinhTrang: {
                    value: this.search.nTinhTrang
                }
            };

            this.store
                .dispatch(Medical.showMedical, this.pageRequest)
                .then((res) => {
                    if (res.code == 200) {
                        this.tableData = res.data;
                    }
                })
                .catch(() => {
                    ElMessage({
                        message: "Lấy dữ liệu thất bại",
                        type: "error"
                    });
                });
        },

        handleOpenAdd() {
            this.$refs.formDataRef.resetFields();

            this.operation = false;

            this.formData = {
                cTenTram: "",
                cMoTa: "",
                cSdt: "",
                cDiaChi: "",
                cGoogleMapUrl: ""
            };

            this.imageFile = [];
        },

        handleOpenEdit(val) {
            this.$refs.formDataRef.resetFields();

            this.operation = true;

            this.formData = {
                ...val
            };

            this.imageFile = [];

            if (val.cBannerUrl) {
                this.addImageFromURL(
                    baseUrl + val.cBannerUrl
                );
            }
        },

        handleClose() {
            this.$refs.formDataRef.resetFields();

            hideModal(
                this.$refs.newsModalRef
            );
        },

        handleDelete(val) {
            this.$confirm(
                "Bạn có muốn xóa không?",
                "Xác nhận",
                {
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy",
                    type: "warning"
                }
            )
                .then(() => {
                    this.store
                        .dispatch(
                            Medical.deleteMedical,
                            val
                        )
                        .then((res) => {
                            if (res.code == 200) {
                                ElMessage({
                                    message:
                                        "Xóa thành công",
                                    type: "success"
                                });

                                this.handleFindPage();
                            }
                        });
                })
                .catch(() => { });
        },

        handleSave() {
            this.$refs.formDataRef.validate(
                (valid) => {
                    if (!valid) return;

                    const formData =
                        new FormData();

                    if (
                        this.imageFile.length > 0 &&
                        this.imageFile[0].raw
                    ) {
                        formData.append(
                            "image",
                            this.imageFile[0].raw
                        );
                    }

                    formData.append(
                        "record",
                        new Blob(
                            [
                                JSON.stringify(
                                    this.formData
                                )
                            ],
                            {
                                type:
                                    "application/json"
                            }
                        )
                    );

                    const action =
                        this.operation
                            ? Medical.updateMedical
                            : Medical.saveMedical;

                    this.store
                        .dispatch(
                            action,
                            formData
                        )
                        .then((res) => {
                            if (
                                res.code == 200
                            ) {
                                ElMessage({
                                    message:
                                        this.operation
                                            ? "Cập nhật thành công"
                                            : "Thêm thành công",
                                    type:
                                        "success"
                                });

                                this.handleFindPage();
                                this.handleClose();
                            }
                        })
                        .catch(() => {
                            ElMessage({
                                message:
                                    "Lưu thất bại",
                                type: "error"
                            });
                        });
                }
            );
        },

        handleChangeFile(
            file,
            imageFile
        ) {
            this.imageFile = [file];

            this.formData.imageFile =
                this.imageFile;
        },

        handleRemoveFile() {
            this.imageFile = [];

            this.formData.imageFile =
                [];
        },

        addImageFromURL(url) {
            fetch(url)
                .then((res) =>
                    res.blob()
                )
                .then((blob) => {
                    const file =
                        new File(
                            [blob],
                            "image.jpg",
                            {
                                type:
                                    blob.type
                            }
                        );

                    this.imageFile.push({
                        name:
                            file.name,
                        url:
                            URL.createObjectURL(
                                file
                            ),
                        status:
                            "success",
                        uid:
                            Date.now(),
                        raw: file
                    });
                });
        },

        handlePictureCardPreview(
            val
        ) {
            this.dialogImageUrl =
                val.url;

            this.dialogVisible = true;
        }
    },

    mounted() {
        this.handleFindPage();
    }
};
</script>